import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';

export interface ContentCategory {
  id: string;
  name: string;
  sort_order: number;
  created_at: string;
}

export function useContentCategories() {
  return useQuery({
    queryKey: ['content_categories'],
    queryFn: async () => {
      const { data, error } = await supabase
        .from('content_categories')
        .select('*')
        .order('sort_order');
      if (error) throw error;
      return data as ContentCategory[];
    },
  });
}

export function useCreateContentCategory() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async (input: { name: string; sort_order?: number }) => {
      const { error } = await supabase.from('content_categories').insert(input);
      if (error) throw error;
    },
    onSuccess: () => qc.invalidateQueries({ queryKey: ['content_categories'] }),
  });
}

export function useUpdateContentCategory() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async ({ id, ...input }: { id: string; name: string; sort_order?: number }) => {
      const { error } = await supabase.from('content_categories').update(input).eq('id', id);
      if (error) throw error;
    },
    onSuccess: () => qc.invalidateQueries({ queryKey: ['content_categories'] }),
  });
}

export function useDeleteContentCategory() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async (id: string) => {
      const { error } = await supabase.from('content_categories').delete().eq('id', id);
      if (error) throw error;
    },
    onSuccess: () => qc.invalidateQueries({ queryKey: ['content_categories'] }),
  });
}
